import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play, Banknote } from "lucide-react";

export function BalloonRisk({ onScore }) {
  const [size, setSize] = useState(50);
  const [banked, setBanked] = useState(0);
  const [round, setRound] = useState(0);
  const [popped, setPopped] = useState(false);
  const [running, setRunning] = useState(false);
  const limit = useRef(0);
  const pending = useRef(0);
  const reported = useRef(false);

  const start = () => { setBanked(0); setRound(1); newBalloon(); setRunning(true); reported.current = false; };
  const newBalloon = () => { setSize(50); setPopped(false); pending.current = 0; limit.current = 4 + Math.floor(Math.random() * 8); };

  const pump = () => {
    if (!running || popped) return;
    pending.current += 1;
    setSize((s) => s + 14);
    if (pending.current >= limit.current) { setPopped(true); }
  };

  const bank = () => {
    if (!running || popped) return;
    setBanked((b) => b + pending.current * 10);
    next();
  };

  const next = () => {
    if (round >= 5) { setRunning(false); if (!reported.current) { reported.current = true; onScore?.(banked + (popped ? 0 : pending.current * 10)); } return; }
    setRound((r) => r + 1); newBalloon();
  };

  return (
    <div className="flex flex-col items-center text-center" data-testid="balloon-risk">
      <div className="flex gap-6 mb-3 font-mono">
        <span className="text-neon-lime text-lg" data-testid="balloon-bank">BANKED: {banked}</span>
        <span className="text-neon-yellow">ROUND: {round}/5</span>
      </div>
      <div className="h-56 flex items-end justify-center mb-4">
        <div className="rounded-full transition-all duration-150" data-testid="balloon"
          style={{ width: size, height: size, background: popped ? "transparent" : "#FF003C", boxShadow: popped ? "none" : "0 0 20px #FF003C" }}>
          {popped && <span className="text-4xl">💥</span>}
        </div>
      </div>
      {!running ? (
        <Button onClick={start} data-testid="balloon-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase h-12 px-8">
          <Play className="w-4 h-4 mr-2 fill-black" /> {round >= 5 ? "Play Again" : "Start"}
        </Button>
      ) : popped ? (
        <>
          <p className="text-neon-pink font-display font-black uppercase mb-3" data-testid="balloon-pop">Popped! Lost this round's points.</p>
          <Button onClick={next} className="bg-neon-cyan text-black rounded-none font-bold uppercase">Next Balloon</Button>
        </>
      ) : (
        <div className="flex gap-3">
          <Button onClick={pump} data-testid="balloon-pump" className="bg-neon-pink text-white rounded-none font-bold uppercase">Pump (+10)</Button>
          <Button onClick={bank} data-testid="balloon-bankbtn" className="bg-neon-lime text-black rounded-none font-bold uppercase"><Banknote className="w-4 h-4 mr-1" /> Bank</Button>
        </div>
      )}
      <p className="text-zinc-500 text-xs font-mono mt-4">Pump to earn points — but bank before it pops or you lose them!</p>
    </div>
  );
}
